import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const UpdateRental = () => {
  const [description, setDescription] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // Removed the useEffect for initial data loading/simulation.
  // The fields will now start empty.

  const handleUpdateRental = () => {
    const rentalId = localStorage.getItem("selectedRentalId");
    if (!rentalId || !token) {
      console.error("Rental ID or token not found.");
      toast.error("Authentication required or no rental selected."); // Added user-friendly toast
      return;
    }

    const updatedRentalData = {
      description: description,
      house_number: houseNumber,
    };

    axios
      .patch(
        `${StandardURL}/iNyumba/admin/rentals/${rentalId}`,
        updatedRentalData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response || "Rental updated successfully!");
        navigate(-1); // Go back to the previous page
      })
      .catch((error) => {
        toast.error(error.response?.data?.response || "Failed to update rental. Please try again.");
        console.error("Error updating rental:", error);
      });
  };

  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page in history
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-xl">
            <h1 className="text-3xl font-extrabold text-gray-900 mb-6 text-center">
              Update Rental Details
            </h1>
            <p className="text-center text-gray-600 mb-8">
              Modify the description and house number for this rental unit.
            </p>

            {/* Removed conditional rendering for loading/error states */}
            <>
              <div className="mb-5">
                <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                  Description:
                </label>
                <input
                  type="text"
                  id="description"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter rental description"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="houseNumber" className="block text-sm font-medium text-gray-700 mb-1">
                  House Number:
                </label>
                <input
                  type="text"
                  id="houseNumber"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value={houseNumber}
                  onChange={(e) => setHouseNumber(e.target.value)}
                  placeholder="e.g., A101, Unit 5"
                />
              </div>

              <div className="flex justify-between items-center mt-6">
                <button
                  onClick={handleUpdateRental}
                  className="w-full sm:w-auto flex justify-center py-2 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                >
                  Update Rental
                </button>
                <button
                  onClick={handleGoBack}
                  className="w-full sm:w-auto flex justify-center py-2 px-6 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ml-4 transition duration-150 ease-in-out"
                >
                  Go Back
                </button>
              </div>
            </>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default UpdateRental;